'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _track = require('./utils/track');

var _track2 = _interopRequireDefault(_track);

var _events = require('./events');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function trackBarrierUltimateOnlyUpgrade() {
    return (0, _track2.default)(_events.EVENT_BARRIER_ULTIMATE_ONLY_UPGRADE);
}

exports.default = trackBarrierUltimateOnlyUpgrade;


//////////////////
// WEBPACK FOOTER
// ./~/rp-analytics/lib/trackBarrierUltimateOnlyUpgrade.js
// module id = 2502
// module chunks = 1